// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/eye.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/eye'

import { Icon, type IconComponentProps } from '../icon'

export const EyeIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
